var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GekkoButton',{staticClass:"p-0 text-info",attrs:{"text":_vm.archivedText,"icon":_vm.archivedIcon,"variant":"link","size":"sm"},on:{"click":function($event){return _vm.toggleArchived()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }